import { useState, useEffect } from 'react'
import { Header } from './Header'
import SideMenu from './SideMenu'
import Footer from './Footer'
import { AmbitoSelectionContext } from './AmbitoSelectionContext'
import { type AmbitoId } from '../data/ambitiStats'

interface AppLayoutProps {
  children: (props: {
    selectedAmbito: AmbitoId | null
    onSelectedAmbitoChange: (ambitoId: AmbitoId | null) => void
  }) => React.ReactNode
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [selectedAmbito, setSelectedAmbito] = useState<AmbitoId | null>(null)
  const [sideMenuOpen, setSideMenuOpen] = useState(false)
  const [theme, setTheme] = useState<'dark' | 'light'>(() => {
    if (typeof window !== 'undefined') {
      return (document.documentElement.getAttribute('data-theme') as 'light' | 'dark') || 'light'
    }
    return 'light'
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (selectedAmbito) {
      window.localStorage.setItem('mb_selected_ambito', selectedAmbito)
      return
    }
    window.localStorage.removeItem('mb_selected_ambito')
  }, [selectedAmbito])

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark')

  return (
    <div className="app">
      <Header onMenuOpen={() => setSideMenuOpen(true)} />

      <SideMenu
        open={sideMenuOpen}
        onClose={() => setSideMenuOpen(false)}
        theme={theme}
        onToggleTheme={toggleTheme}
      />

      <div className="app-body">
        <div className="app-content">
          <AmbitoSelectionContext.Provider value={selectedAmbito}>
            {children({ selectedAmbito, onSelectedAmbitoChange: setSelectedAmbito })}
          </AmbitoSelectionContext.Provider>
        </div>
      </div>
      <Footer />
    </div>
  )
}
